import { useAccessRoles } from "app/components/AccessRoles"
import { Roles } from "app/models/user"
import { getPractice } from "app/redux/practice/practice.selectors"
import { useIntl } from "react-intl"
import { useSelector } from "react-redux"
import { FeatureFlagTypes } from "./types"

export const useGetDefaultSelectedFeatures = () => {
  const practice = useSelector(getPractice)

  return Object.values(FeatureFlagTypes).filter(feature => practice?.features?.[feature])
}

export const useGetSelectedFeaturesOptions = () => {
  const { messages } = useIntl()
  const { isAllowed } = useAccessRoles([Roles.Devops])

  return Object.values(FeatureFlagTypes).map(feature => ({
    label: messages[`feature.${feature}`] as string,
    value: feature,
    disabled: !isAllowed,
  }))
}
